var request=require("./request").default;

exports.install = (Vue) => {
    Vue.prototype.$api = request
}